import React, { useState, useEffect, useCallback } from 'react';
import { Button, Offcanvas, Spinner, Modal, Dropdown, Image } from 'react-bootstrap';
import appUrl from '../../appUrl';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Table.css';
import { Link, useParams } from 'react-router-dom';
import { FaEye, FaPlus } from "react-icons/fa";
import { FaTrashCan } from "react-icons/fa6";
import { MdEdit } from "react-icons/md";
// import { FaUserCircle, FaPlus } from "react-icons/fa"; 
import { FaUserCircle } from "react-icons/fa"; // Icons
// import { collectionGroup } from 'firebase/firestore';
// import { Modal } from 'react-bootstrap';
// import { FaPlus } from 'react-icons/fa';
import { FaGoogle, FaApple, FaEnvelope } from "react-icons/fa";




const UserTable = ({ role }) => {
    // const { userId } = useParams();
    const AppUrl = appUrl();

    const [dataLoading, setDataLoading] = useState(false);
    const [projects, setProjects] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [formData, setFormData] = useState({
        profile_photo: "",
        username: "",
        email: "",
        status: "",
        password: "",
        mobile_number: "",
        country: "",
        role: "",
        recommended_by: "",
    });

    const [refreshData, setRefreshData] = useState(false);
    const [showUserModal, setShowUserModal] = useState(false);
    //   // Handle open modal
    //   const handleShowModal = () => setShowModal(true);

    //   // Handle close modal
    //   const handleCloseModal = () => setShowModal(false);


    // Handle open modal
    // const handleModalUser = () => setShowUserModal(true);
    // cons setFormData({ ...formData, [e.target.name]: e.target.value });
    //   };t handleChange = (e) => {
    //    


    const handleModalUser = (behaviour, row = null) => {
        if (behaviour === "edit_user") {
            setFormData((prev) => ({
                ...prev,
                profile_photo: row.profile_photo || "",
                username: row.username || "",
                email: row.email || "",
                // status: row.status || "",
                mobile_number: row.mobile_number || "",
                country: row.country || "",
                recommended_by: row.recommended_by || "",

            }));
        } else if (behaviour === "add_user") {
            setFormData((prev) => ({
                ...prev,
                profile_photo: "",
                username: "",
                email: "",
                status: "",
                password: "",
                mobile_number: "",
                country: "",
                role: "",
                recommended_by: "",
            }));
        }
        setModalContent({ behaviour, row });
        setShowUserModal(true);
    };

    // Handle close modal
    const handleCloseModalUser = () => setShowUserModal(false);



    const handleGetAllReports = useCallback(async () => {
        setDataLoading(true);
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(`${AppUrl}/users/${role}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            const data = await response.json();
            if (data.status) {
                setProjects(data.data);
                setTotalCount(data.data.length);
            } else {
                toast.error("Failed to fetch data");
            }
        } catch (error) {
            console.error("Error fetching reports:", error);
            toast.error("Error fetching reports");
        } finally {
            setDataLoading(false);
        }
    }, [AppUrl, role]);

    const handlePageChange = (page, sizePerPage) => {
        // setCurrentPage(page);
        setCurrentPage(1);
        setPageSize(sizePerPage);
    };

    useEffect(() => {
        handleGetAllReports();
    }, [role, refreshData, handleGetAllReports]);

    const handleStatusChange = async (id, status) => {
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(`${AppUrl}/user/${id}/status`, {
                method: "PATCH",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ status }),
            });

            if (response.ok) {
                toast.success("Status updated successfully");
                setRefreshData(prev => !prev)
            } else {
                const data = await response.json();
                toast.error(data.message || "Failed to update status");
            }
        } catch (error) {
            console.error("Error updating status:", error);
            toast.error("Error updating status");
        }
    };

    const handleModal = (behaviour, row) => {
        setModalContent({ behaviour, row })
        setShowModal(true)
    }


    //     const handleAddUser =  async (e) => {
    //    e.preventDefault();
    //    try{

    //    }catch(error){
    //     console.log(error)
    //    }     
    //     }

    const handleAddUser = async (e) => {
        e.preventDefault();
        const form = formData;
        const formDataToSend = new FormData();

        formDataToSend.append('username', form.username);
        formDataToSend.append('email', form.email);
        formDataToSend.append('password', form.password);
        formDataToSend.append('status', form.status);
        formDataToSend.append('mobile_number', form.mobile_number);
        formDataToSend.append('country', form.country);
        formDataToSend.append('role', form.role);
        formDataToSend.append('recommended_by', form.recommended_by);


        if (typeof form.profile_photo === 'object') {
            formDataToSend.append('profile_photo', form.profile_photo);
        }

        const token = localStorage.getItem("token");

        try {
            setDataLoading(true);
            const response = await fetch(`${AppUrl}/service/create-user`, {
                method: 'POST',
                body: formDataToSend,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Failed to add user');

            toast.success('User added successfully!');
            setRefreshData(prev => !prev);
            setShowModal(false);
        } catch (error) {
            toast.error(error.message || 'Error adding user');
        } finally {
            setDataLoading(false);
        }
    };


    const handleEditUser = async (e, userId) => {
        console.log("userIdd", userId)
        e.preventDefault();
        const form = formData;
        const formDataToSend = new FormData();

        formDataToSend.append('username', form.username);
        // formDataToSend.append('email', form.email);
        // formDataToSend.append('password', form.password);
        // formDataToSend.append('status', form.status);
        formDataToSend.append('mobile_number', form.mobile_number);
        formDataToSend.append('country', form.country);
        // formDataToSend.append('recommended_by', form.recommended_by);

        if (typeof form.profile_photo === 'object') {
            formDataToSend.append('profile_photo', form.profile_photo);
        }

        const token = localStorage.getItem("token");

        try {
            setDataLoading(true);
            const response = await fetch(`${AppUrl}/service/edit-user/${userId}`, {
                method: 'PATCH',
                body: formDataToSend,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Failed to update user');

            toast.success('User updated successfully!');
            setRefreshData(prev => !prev);
            setShowModal(false);
        } catch (error) {
            toast.error(error.message || 'Error updating user');
        } finally {
            setDataLoading(false);
        }
    };




    const handleDeleteUser = async (e, userId) => {
        console.log("userid", userId)
        e.preventDefault();
        const token = localStorage.getItem('token');
        if (!token) throw new Error("Invalid Operation!")

        try {
            setDataLoading(true);
            const response = await fetch(`${AppUrl}/users/${userId}/delete`, {
                method: "DELETE",
                headers: {

                    Authorization: `Bearer ${token}`,
                }
            });
            const data = await response.json();
            if (data.status) {
                toast.success('User deleted successfully!');
                setRefreshData(prev => !prev)
            } else {
                throw new Error("Failed to delete User")
            }
        } catch (error) {
            console.error(error);
            toast.error(error)
        } finally {
            setDataLoading(false);
            setShowModal(false);
        }
    }

    const columns = [
        { text: 'S No.', dataField: 'index', formatter: (cell, row, rowIndex) => pageSize * (currentPage - 1) + rowIndex + 1 },
        { text: 'Name', dataField: 'username', filter: textFilter({ placeholder: '' }) },
        { text: 'Email', dataField: 'email', filter: textFilter({ placeholder: '' }), formatter: (cell) => cell || '-' },
        { text: 'Country', dataField: 'country', filter: textFilter({ placeholder: '' }), formatter: (cell) => cell || '-' },
        { text: 'Recom. By', dataField: 'recommended_by', filter: textFilter({ placeholder: '' }), formatter: (cell) => cell || '-' },
        // { text: 'Login Source', dataField: 'source', formatter: (cell) => cell || '-' },

        {
            text: 'Login Source',
            dataField: 'source',
            formatter: (cell, row) => {
                if (row.userGoogleInfo?.google_id)
                    return (
                        <span>
                            <FaGoogle color="#555" size={18} />
                        </span>
                    );
                if (row.userAppleInfo?.apple_id)
                    return (
                        <span>
                            <FaApple color="#555" size={20} />
                        </span>
                    );
                return (
                    <span>
                        <FaEnvelope color="#555" size={18} />
                    </span>
                );
            }
        },
        {
            text: 'Status',
            dataField: 'status',
            formatter: (cell, row) => (
                <Dropdown onSelect={(status) => handleStatusChange(row._id, status)}>
                    <Dropdown.Toggle style={{ borderRadius: '20px', fontSize: '14px' }} variant={cell === "active" ? "success" : cell === "deleted" ? "danger" : "warning"}>
                        {cell === "active" ? "Active" : cell === "deleted" ? "Deleted" : "Inactive"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu >
                        {cell !== "active" && <Dropdown.Item style={{ fontSize: '14px' }} eventKey="active">Active</Dropdown.Item>}
                        {cell !== 'inactive' && <Dropdown.Item style={{ fontSize: '14px' }} eventKey="inactive">Inactive</Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>
            )
        },
        // {
        //     text: 'Profile',
        //     formatter: (cell, row) => (
        //         <div className=''>
        //             <Link to={{
        //                     pathname: "/home/viewprofile",
        //                     search: `?role=${role}&id=${row._id}`,
        //             }}>
        //                 <Button size="sm" className='view-details-button-lg py-2'>
        //                 View</Button>
        //             </Link>
        //         </div> 
        //     )
        // },
        // {
        //     text: 'Action',
        //     formatter: (cell, row) => (
        //         <div className=''>
        //             <Button variant='danger' size="sm" className='delete-button-lg py-2'>
        //                 Delete
        //             </Button>
        //         </div> 
        //     )
        // }
        {
            text: 'Actions',
            formatter: (cell, row) => (
                <div className='flex-center' >
                    <Link className='user-crud-icon' to={{
                        pathname: "/home/view/profile",
                        search: `?role=${role}&id=${row._id}`,
                    }}>
                        <span className=''>
                            <FaEye />
                        </span>
                    </Link>
                    <span onClick={(e) => handleModalUser("edit_user", row)} className='user-crud-icon'>
                        <MdEdit />
                    </span>
                    <span onClick={() => handleModal('delete_user', row)} className='user-crud-icon' style={{ color: 'red' }}>
                        <FaTrashCan />
                    </span>
                </div>
            )
        }
    ];

    return (
        <>

            <ToastContainer />

            {dataLoading ? (


                <div className='loading-spinner'>
                    <Spinner animation="border" role="status" />
                </div>
            ) : (
                <>
                    <div className='flex align-items-center justify-content-end'>
                        {/* <Button 
                        className="add-item-modal-open-btn flex gap-1 items-center justify-center border-none"
                        > */}

                        <Button
                            className="add-item-modal-open-btn flex gap-1 items-center justify-center border-none"
                            onClick={() => handleModalUser("add_user")}
                        >
                            <FaPlus />
                            <span>Add new</span>
                        </Button>



                    </div>
                    <BootstrapTable
                        bootstrap4
                        keyField="_id"
                        data={projects}
                        columns={columns}
                        filter={filterFactory()}
                        pagination={paginationFactory({
                            page: currentPage,
                            sizePerPage: pageSize,
                            totalSize: totalCount,
                            onPageChange: handlePageChange,
                            sizePerPageRenderer: () => null,
                            showTotal: true,
                            paginationTotalRenderer: (from, to, total) => (
                                <div className="pagination-and-entries">
                                    <p className="entries">
                                        Showing {from} to {to} of {total} entries
                                    </p>
                                </div>
                            )
                        })}
                    />
                </>
            )}
            <Modal show={showModal} onHide={() => { setShowModal(false); setModalContent(null); }}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalContent?.behaviour === 'edit_user' ? `Edit ${role}` : modalContent?.behaviour === 'delete_user' ? `Delete ${role}` : `Add new ${role}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalContent?.behaviour === 'edit_user' && (
                        <div className='flex items-center justify-between gap-2'>

                        </div>
                    )}
                    {modalContent?.behaviour === 'delete_user' && (
                        <div>
                            <span>{`Are you sure, you want to delete`}</span>
                            <span className='font-bold mx-1'>{modalContent.row.username}?</span>

                        </div>
                    )}
                    {modalContent?.behaviour === 'add_new_user' && (
                        <div className='flex items-center justify-between gap-2'>

                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='modal-cancel-btn' variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    {modalContent?.behaviour === 'edit_user' && (
                        <Button
                            disabled={dataLoading}
                            className='modal-edit-btn'
                            onClick={(e) => handleEditUser(e, modalContent.row._id)}>
                            {dataLoading ?
                                <div className='flex-center'>
                                    <Spinner style={{ width: '25px', height: '25px' }} animation="border" role="status" />
                                </div>
                                :
                                <span>Save Changes</span>}
                        </Button>
                    )}
                    {modalContent?.behaviour === 'delete_user' && (
                        <Button
                            disabled={dataLoading}
                            className='modal-delete-btn'
                            variant="danger"
                            onClick={(e) => handleDeleteUser(e, modalContent.row._id)}>
                            {dataLoading ?
                                <div className='flex-center'>
                                    <Spinner style={{ width: '25px', height: '25px' }} animation="border" role="status" />
                                </div>
                                :
                                <span>Delete</span>}
                        </Button>
                    )}
                    {modalContent?.behaviour === 'add_new_user' && (
                        <Button
                            disabled={dataLoading}
                            className='modal-add-btn'
                            variant="primary"
                            onClick={(e) => handleAddUser(e)}>
                            {dataLoading ?
                                <div className='flex-center'>
                                    <Spinner style={{ width: '25px', height: '25px' }} animation="border" role="status" />
                                </div>
                                :
                                <span>Create</span>}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
            {modalContent && modalContent?.behaviour === "add_user" ?
                <UserModal show={showUserModal} modalContent={modalContent} content={formData} setData={setFormData} handleSave={handleAddUser} handleClose={handleCloseModalUser} />
                :
                <UserModal show={showUserModal} modalContent={modalContent} content={formData} setData={setFormData} handleSave={handleEditUser} handleClose={handleCloseModalUser} />
            }
        </>
    );
};

export default UserTable;

const UserModal = ({ show, handleClose, handleSave, content, modalContent, setData }) => {
    const [localImageUrl, setLocalImageUrl] = useState(null);
    console.log(content)

    // Handle image selection
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setData((prev) => ({ ...prev, profile_photo: file }));
            const imageUrl = URL.createObjectURL(file);
            setLocalImageUrl(imageUrl);
        }

        // Reset input so selecting the same file again still triggers change
        e.target.value = null;
    };

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end" style={{ width: '600px' }}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{modalContent?.behaviour === "add_user" ? "Add new user" : "Edit user"}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>

                <div className="text-center mb-3 position-relative">

                    <div className="position-relative d-inline-block">
                        {/* Profile Preview or Default Icon */}
                        {content.profile_photo !== "" || localImageUrl ? (
                            <>
                                <img
                                    src={localImageUrl || content?.profile_photo}
                                    alt="Profile Preview"
                                    className="rounded-circle border"
                                    style={{ width: "80px", height: "80px", objectFit: "cover" }}
                                />

                                {/* Cancel Icon (top-right corner) */}
                                <button
                                    className="btn btn-danger btn-sm position-absolute"
                                    style={{ top: "-5px", right: "-5px", borderRadius: "50%", width: "25px", height: "25px", padding: 0, fontSize: "14px" }}
                                    onClick={() => { setLocalImageUrl(null); setData(prev => ({ ...prev, "profile_photo": "" })) }}
                                >
                                    &times;
                                </button>
                            </>
                        ) : (
                            <FaUserCircle size={80} color="gray" />
                        )}

                        {/* Hidden File Input */}
                        <input
                            type="file"
                            accept="image/*"
                            className="d-none"
                            id="profileImageInput"
                            onChange={handleImageChange}
                        />

                        {/* Plus Icon (bottom-right corner) */}
                        <button
                            className="btn btn-primary rounded-circle position-absolute"
                            style={{ bottom: 0, right: 0, width: "35px", height: "35px", display: "flex", alignItems: "center", justifyContent: "center" }}
                            onClick={() => document.getElementById('profileImageInput').click()}
                        >
                            <FaPlus size={16} />
                        </button>
                    </div>


                </div>

                {/* User Details Inputs */}
                <label>Username:</label>
                <input type="text" value={content.username} name='username' className="form-control mb-2" placeholder="Username" onChange={(e) => setData(prev => ({ ...prev, username: e.target.value }))} />

                <label>Email:</label>
                <input type="text" value={content.email} name='email' className="form-control mb-2" placeholder="Email" onChange={(e) => setData(prev => ({ ...prev, email: e.target.value }))} disabled/>

                {modalContent?.behaviour === "add_user" ?
                    <>
                        <label>Password:</label>
                        <input type="text" value={content.password} name='password' className="form-control mb-2" placeholder="password" onChange={(e) => setData(prev => ({ ...prev, password: e.target.value }))} />
                    </>
                    :
                    null
                }

                {/* <label className="form-label">Status:</label>
                <Dropdown className="mb-2">
                    <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start">
                        {content?.status || "Select Status"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100">
                        {["Active", "Inactive", "Pending"].map((status) => (
                            <Dropdown.Item
                                key={status}
                                onClick={() => setData(prev => ({ ...prev, status }))}
                            >
                                {status}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown> */}

                <label>Mobile Number:</label>
                <input type="text" value={content.mobile_number} name='mobile_number' className="form-control mb-2" placeholder="Mobile" onChange={(e) => setData(prev => ({ ...prev, mobile_number: e.target.value }))} />

                <label>Country:</label>
                <input type="text" value={content.country} name='country' className="form-control mb-2" placeholder="Country" onChange={(e) => setData(prev => ({ ...prev, country: e.target.value }))} />

                {modalContent?.behaviour === "add_user" ?
                    <>
                        <label>Role:</label>
                        <input type="text" value={content.role} name='role' className="form-control mb-2" placeholder="Role" onChange={(e) => setData(prev => ({ ...prev, role: e.target.value }))} />
                    </>
                    :
                    null
                }

                {/* <label className="form-label">Recommnded By: </label>
                <Dropdown className="mb-2" drop="down">
                    <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start">
                        {content.recommended_by || "Recommended By"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100">
                        {["By friend ", "social media", "agent"].map((person) => (
                            <Dropdown.Item
                                key={person}
                                onClick={() => setData(prev => ({ ...prev, recommended_by: person }))}
                            >
                                {person}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown> */}

            </Offcanvas.Body>
            <div className="p-3">
                <Button variant="secondary" onClick={handleClose} className="me-2">
                    Close
                </Button>
                {modalContent?.behaviour === "add_user" ?
                    <Button variant="success" onClick={handleSave}>
                        Add User
                    </Button> :
                    <Button onClick={(e) => handleSave(e, modalContent.row._id)}>Save Changes</Button>
                }
            </div>
        </Offcanvas>
    );
};

